import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { _setBackendStoreRef } from './Backend';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

function configureStore() {
  let store = createStore(persistedReducer, applyMiddleware(thunk))
  let persistor = persistStore(store)
  return { store, persistor }
}

export const { store, persistor } = configureStore();

// Wire Redux store into Backend.js so request headers can include the
// current deal partner id (X-Deal-Partner-Id).
_setBackendStoreRef(store);
